<template>
  <div class="home">
    <Hero />
    <div class="container">
      <div class="events-section">
        <h2 class="section-title">聚会活动</h2>
        <div class="events-list">
          <EventCard 
            v-for="event in events" 
            :key="event.id"
            :event="event"
            @view-detail="viewEventDetail"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import EventCard from '@/components/EventCard.vue'
import events from '@/data/events.json'

export default {
  name: 'Home',
  components: {
    Hero,
    EventCard
  },
  data() {
    return {
      events: events
    }
  },
  methods: {
    viewEventDetail(eventId) {
      this.$router.push({ name: 'EventDetail', params: { id: eventId } })
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  background: #F0F4F8;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
}

.events-section {
  margin-top: 20px;
}

.section-title {
  font-size: 24px;
  color: #1A2332;
  margin-bottom: 25px;
  padding-left: 15px;
  border-left: 4px solid #005BAF;
  font-weight: 600;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

@media (min-width: 768px) {
  .events-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 30px 15px;
  }
  
  .section-title {
    font-size: 20px;
  }
}
</style>
